let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9AR7a")).then(() => parcelRequire('5uJ2G'));